import styled from "styled-components";

export const AdviceGridRowColumn = styled.td`
    width: ${({ width }) => width}%;
    padding: 0.6rem !important;
    vertical-align: middle;
`;

export default AdviceGridRowColumn;